import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function AdminLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password, true); // true for isAdminLogin
            toast.success("Super Admin authenticated.");
            navigate('/adminpanel/dashboard');
        } catch (err) {
            toast.error(err.response?.data?.detail || "Admin authentication failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#0A192F] flex flex-col items-center justify-center p-4 relative overflow-hidden">
            <div className="absolute inset-0 z-0 opacity-10" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1559612589-9df3eaf13f28?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxmaW5hbmNpYWwlMjBjb3Jwb3JhdGUlMjBvZmZpY2V8ZW58MHx8fHwxNzkwNDg4NjI2fDA&ixlib=rb-4.1.0&q=85')", backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
            
            <div className="z-10 bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full border-t-4 border-[#EAB308]">
                <div className="flex justify-center mb-6">
                    <img src="https://customer-assets-jai6qajn.emergentagent.net/job_financepro-57/artifacts/xfybzyti_Rc%20company%20png%20logo%20%281%29.jpg" alt="RC Company" className="w-20 h-20 rounded-2xl object-contain shadow-lg bg-white" />
                </div>
                <div className="text-center mb-8">
                     <h1 className="text-2xl font-bold text-[#0F284E] font-['Cabinet_Grotesk'] tracking-tight">Super Admin Command</h1>
                     <p className="text-slate-500 text-sm mt-1">Multi-tenant management portal</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-5">
                    <div>
                        <label className="block text-sm font-semibold text-slate-700 mb-1.5">Admin Email</label>
                        <input 
                            type="email"
                            data-testid="admin-login-email-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full h-11 px-3.5 rounded-lg border border-slate-300 bg-slate-50 text-slate-900 focus:outline-none focus:ring-2 focus:ring-[#0A192F] focus:border-transparent font-sans"
                            placeholder="admin@rccompany.in"
                            required
                        />
                    </div>
                    
                    <div>
                        <label className="block text-sm font-semibold text-slate-700 mb-1.5">Secure Password</label>
                        <input 
                            type="password"
                            data-testid="admin-login-password-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full h-11 px-3.5 rounded-lg border border-slate-300 bg-slate-50 text-slate-900 focus:outline-none focus:ring-2 focus:ring-[#0A192F] focus:border-transparent font-sans"
                            placeholder="••••••••"
                            required
                        />
                    </div>
                    
                    <button 
                        type="submit" 
                        data-testid="admin-login-submit-button"
                        disabled={loading}
                        className="w-full h-12 mt-6 bg-[#EAB308] hover:bg-[#CA8A04] text-[#0A192F] font-bold rounded-lg shadow-sm transition-all active:scale-[0.98] disabled:opacity-70 flex justify-center items-center"
                    >
                        {loading ? (
                           <div className="w-5 h-5 border-2 border-[#0A192F]/30 border-t-[#0A192F] rounded-full animate-spin"></div>
                        ) : "Authenticate Access"}
                    </button>
                </form>
            </div>
        </div>
    )
}
